const standardImageExtensions = ['png', 'jpg', 'jpeg', 'webp', 'svg'];

export default standardImageExtensions;